// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1Kg42","gfeWrapper":"CalendarEvent_gfeWrapper__3uvfY"};